import Vue from 'vue'
import VueRouter from 'vue-router'
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}
VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
	if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
	return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter);

import store from '@/store/index.js'
import login from '@/views/login/login.vue'
const home = () => import('@/views/home/home.vue')
const userMangement = () => import('@/views/users/userMangement/userMangement.vue')
const signInHistory = () => import('@/views/users/signInHistory/signInHistory.vue')
const signInHistoryDetail = () => import('@/views/users/signInHistoryDetail/signInHistoryDetail.vue')
const writer = () => import('@/views/books/writer/writer.vue')
const bookMangment = () => import('@/views/books/bookMangment/bookMangment.vue')
const bookMangmentImage = () => import('@/views/books/bookMangmentImage/bookMangmentImage.vue')
const books = () => import('@/views/books/books/books/books.vue')
const booksDetail = () => import('@/views/books/books/booksDetail/booksDetail.vue')
const vipLevl = () => import('@/views/customer/vipLevl/vipLevl.vue')
const customers = () => import('@/views/customer/customer/customer.vue')
const customersDeposit = () => import('@/views/customer/customersDeposit/customersDeposit.vue')
const customersPayMoney = () => import('@/views/customer/customersPayMoney/customersPayMoney.vue')
const customersRefund = () => import('@/views/customer/customersRefund/customersRefund.vue')
const borrowBooks = () => import('@/views/borrowAndReturn/borrowBooks/borrowBooks.vue')
const returnBooks = () => import('@/views/borrowAndReturn/returnBooks/returnBooks.vue')
const sellbooks = () => import('@/views/borrowAndReturn/sellbooks/sellbooks.vue')
const weChatBorrowBooks = () => import('@/views/weChat/borrowBook/borrowBook.vue')
const weChatBorrowBooksDetail = () => import('@/views/weChat/borrowBookDetail/borrowBookDetail.vue')
const weChatTransportorder = () => import('@/views/weChat/transportOrder/transportOrder.vue')
const weChatTransportorderDetail = () => import('@/views/weChat/orderBooksDetail/orderBooksDetail.vue')
const weChatReturnOrder = () => import('@/views/weChat/returnOrder/returnOrder.vue')
const weChatReturnBooks = () => import('@/views/weChat/returnBooks/returnBooks.vue')
const weChatReturnBooksDetail = () => import('@/views/weChat/returnBooksDetail/returnBooksDetail.vue')
const abnormal = () => import('@/views/borrowAndReturn/abnormal/abnormal.vue')
const orderQuery = () => import('@/views/query/order/orderQuery/orderQuery.vue')
const customerQuery = () => import('@/views/query/customer/customerQuery/customerQuery.vue')
const changePassWorld = () => import('@/views/login/changePassWorld/changePassWorld.vue')
const queryBook = () => import('@/views/books/queryBook/queryBook.vue')
const queryMoney = () => import('@/views/query/money/queryMoney/queryMoney.vue')
const queryDay = () => import('@/views/query/queryDay/queryDay/queryDay.vue')
const booksSeries = () => import('@/views/books/booksSeries/booksSeries.vue')
const movebooks = () => import('@/views/books/movebooks/movebooks.vue')
const queryBookBorrowHistory = () => import('@/views/books/queryBook/queryBookBorrowHistory/queryBookBorrowHistory.vue')
const queryBookmoveHistory = () => import('@/views/books/queryBook/queryBookMoveHistory/queryBookMoveHistory.vue')

const AreaMangment = () => import('@/views/shops/AreaMangment/AreaMangment.vue')
const ShopMangment = () => import('@/views/shops/ShopMangment/ShopMangment.vue')

const subjectSet = () => import('@/views/subject/subjectSet/subjectSet.vue')
const shopSubject = () => import('@/views/subject/shopSubject/shopSubject.vue')
const shopSubjectSignUp = () => import('@/views/subject/shopSubjectSignUp/shopSubjectSignUp.vue')
const shopSubjectSignUpDetail = () => import('@/views/subject/shopSubjectSignUp/shopSubjectSignUpDetail/shopSubjectSignUpDetail.vue')

const subjectFeedback = () => import('@/views/subject/subjectFeedback/subjectFeedback.vue')
const subjectFeedbackDetail = () => import('@/views/subject/subjectFeedback/subjectFeedbackDetail/subjectFeedbackDetail.vue')


const routes = [{
		path: '/AreaMangment',
		component: AreaMangment,
		meta: {
			title: '地区管理'
		}
	}, {
		path: '/queryDay',
		component: queryDay,
		meta: {
			title: '借出书籍'
		}
	},
	{
		path: '/SubjectSignUp',
		component: shopSubjectSignUp,
		meta: {
			title: '课程报名'
		}
	},
	{
		path: '/SubjectSignUpDetail/:ShopSubjectID',
		component: shopSubjectSignUpDetail,
		meta: {
			title: '课程报名详情'
		}
	},
	{
		path: '/customersRefund',
		component: customersRefund,
		meta: {
			title: '会员退费'
		}
	},
	{
		path: '/subjectFeedback',
		component: subjectFeedback,
		meta: {
			title: '课程反馈'
		}
	},
	{
		path: '/subjectFeedbackDetail/:ShopSubjectID',
		component: subjectFeedbackDetail,
		meta: {
			title: '课程反馈详情'
		}
	},
	{
		path: '/queryDay/orderDetail/:orderID',
		component: () => import('views/query/order/orderQueryDetail/orderQueryDetail.vue'),
		meta: {
			title: '订单详情'
		}
	},
	{
		path: '/shopSubject',
		component: shopSubject,
		meta: {
			title: '店铺课程'
		}
	},
	{
		path: '/subjectSet',
		component: subjectSet,
		meta: {
			title: '课程设置'
		}
	},
	{
		path: '/ShopMangment',
		component: ShopMangment,
		meta: {
			title: '店铺管理'
		}
	},
	{
		path: '/abnormal',
		component: abnormal,
		meta: {
			title: '异常还书'
		}
	},
	{
		path: '/movebook',
		component: movebooks,
		meta: {
			title: '图书调动'
		}
	},
	{
		path: '/bookSeries',
		component: booksSeries,
		meta: {
			title: '书籍分类'
		}
	},
	{
		path: '/queryMoney',
		component: queryMoney,
		meta: {
			title: '收入查询'
		}
	},
	{
		path: '/sellbooks',
		component: sellbooks,
		meta: {
			title: '图书售出'
		}
	},
	{
		path: '/queryBook/queryBookBorrowHistory/:BookDetailID',
		component: queryBookBorrowHistory,
		meta: {
			title: '借出记录'
		}
	},
	{
		path: '/queryBook/queryBookmoveHistory/:BookDetailID',
		component: queryBookmoveHistory,
		meta: {
			title: '位置记录'
		}
	},
	{
		path: '/queryBook',
		component: queryBook,
		meta: {
			title: '图书查询'
		}
	},
	{
		path: '/changePassWorld',
		component: changePassWorld,
		meta: {
			title: '修改密码'
		}
	},
	{
		path: '/orderQuery',
		component: orderQuery,
		meta: {
			title: '订单查询'
		}
	},
	{
		path: '/orderQuery/orderDetail/:orderID',
		component: () => import('views/query/order/orderQueryDetail/orderQueryDetail.vue'),
		meta: {
			title: '订单详情'
		}
	},
	{
		path: '/orderQuery/orderHistory/:orderID',
		component: () => import('views/query/order/orderQueryHistory/orderQueryHistory.vue'),
		meta: {
			title: '订单操作历史'
		}
	},
	{
		path: '/customerQuery',
		component: customerQuery,
		meta: {
			title: '客户查询'
		}
	},
	{
		path: '/customerQuery/customerPayRecord/:CustomerID',
		component: () => import('views/query/customer/customerPayRecord/customerPayRecord.vue'),
		meta: {
			title: '订单详情'
		}
	},
	{
		path: '/weChat/returnBooks/returnBooksDetail/:orderID',
		component: weChatReturnBooksDetail,
		meta: {
			title: '微信还书单还书'
		}
	},
	{
		path: '/weChat/returnBooks',
		component: weChatReturnBooks,
		meta: {
			title: '微信还书订单'
		}
	},
	{
		path: '/weChat/returnOrder',
		component: weChatReturnOrder,
		meta: {
			title: '微信还书订单'
		}
	},
	{
		path: '',
		component: login,
		meta: {
			title: '系统登录'
		}
	},
	{
		path: '/login',
		component: login,
		meta: {
			title: '系统登录'
		}
	},
	{
		path: '/home',
		component: home,
		meta: {
			title: '首页'
		}
	},
	{
		path: '/userMangement',
		component: userMangement,
		meta: {
			title: '员工管理'
		}
	},
	{
		path: '/signInHistory',
		component: signInHistory,
		meta: {
			title: '登录记录'
		}
	},
	{
		path: '/bookMangmentImage/:booksID',
		component: bookMangmentImage,
		meta: {
			title: '书籍图片'
		}
	},
	{
		path: '/signInHistoryDetail/:userID',
		component: signInHistoryDetail,
		meta: {
			title: '登录记录'
		}
	},
	{
		path: '/writer',
		component: writer,
		meta: {
			title: '作者管理'
		}
	},
	{
		path: '/bookMangment',
		component: bookMangment,
		meta: {
			title: '书籍归档'
		}
	},
	{
		path: '/books',
		component: books,
		meta: {
			title: '图书管理'
		}
	},
	{
		path: '/booksDetail/:booksID/:areaID',
		component: booksDetail,
		meta: {
			title: '图书管理'
		}
	},
	{
		path: '/vipLevl',
		component: vipLevl,
		meta: {
			title: '会员设置'
		}
	},
	{
		path: '/newCustomers',
		component: customers,
		meta: {
			title: '会员管理'
		}

	},
	{
		path: '/newCustomers/customerAddress/:customerID',
		component: () => import('@/views/customer/customerAddress/customerAddress.vue'),
		meta: {
			title: '借书地址'
		}
	
	},
	{
		path: '/customerDeposit',
		component: customersDeposit,
		meta: {
			title: '押金管理'
		}
	},
	{
		path: '/customerPayMoney',
		component: customersPayMoney,
		meta: {
			title: '会员缴费'
		}
	},
	{
		path: '/borrowBooks',
		component: borrowBooks,
		meta: {
			title: '会员借书'
		}
	},
	{
		path: '/returnBooks',
		component: returnBooks,
		meta: {
			title: '会员还书'
		}
	},
	{
		path: '/weChat/borrowOrder',
		component: weChatBorrowBooks,
		meta: {
			title: '微信订单配书'
		}
	},
	{
		path: '/weChat/borrowOrder/borrowOrderDetail/:orderID',
		component: weChatBorrowBooksDetail,
		meta: {
			title: '微信订单配书详情'
		}
	},
	{
		path: '/weChat/transportOrder',
		component: weChatTransportorder,
		meta: {
			title: '微信订单配送'
		}
	}, {
		path: '/weChat/transportOrder/transportOrderDetail/:orderID',
		component: weChatTransportorderDetail,
		meta: {
			title: '微信订单配送详情'
		}
	}

];

const router = new VueRouter({
	routes,
	mode: 'hash'
})

//前置钩子（hook）
router.beforeEach((to, from, next) => {
	if (to.path != "/login") {
		if (store.state.user.UserID == 0) {
			next('/login');
		} else {
			document.title = "布克de奇幻世界—" + to.meta.title;
			next();
		}
	} else {
		document.title = "布克de奇幻世界—" + to.meta.title;
		next();
	}
});
//后置钩子（hook）
router.afterEach((to, from) => {
	//console.log("-路由后置钩子-")
});
export default router
